import angular from 'angular';
import GravitySettingsProvider from './gravitySettingsProvider';

const moduleName = angular.module('7Terminal.Gravity', [])
  .provider('GravitySettings', GravitySettingsProvider)
  .name;

export default moduleName;
